<template>
  <div>
    <cv-dialog v-model="showCV" :id="artist.id" />

    <base-card class="px-3 pb-4" color="secondary" v-if="artist">
      <h1 class="py-3">{{ artist.name }}</h1>

      <v-img
        sizes="500px"
        aspect-ratio="1"
        :src="artist.media.url"
        :srcset="artist.media.srcset"
        :style="{'background-color': artist.media.color }"
      />

      <v-layout row align-center justify-center>
        <v-flex grow>
          <h3 class="py-3" v-if="!artist.is_merchandise">{{ $t('COMMON.ABOUT_ME') }}</h3>
        </v-flex>
        <v-flex shrink v-if="artist.hasCV">
          <tk-btn small outline class="cv-btn" @click="showCV = true">CV</tk-btn>
        </v-flex>
      </v-layout>
      <template v-if="artist.about">
        <p class="pre-wrap">{{ aboutProxy }}</p>
        <div class="text-xs-right" v-if="artist.about.length > 300">
          <tk-btn
            class="more-btn"
            small
            outline
            @click="aboutExpanded = !aboutExpanded"
          >{{ $t(aboutExpanded ? 'COMMON.LESS' : 'COMMON.MORE') }}</tk-btn>
        </div>
      </template>

      <iframe
        v-if="artist.video"
        class="artist-video"
        :src="`https://www.youtube-nocookie.com/embed/${artist.video}`"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
      ></iframe>

      <ArtworkSubscribeForm
        v-if="!artist.is_merchandise"
        black
        :artist="artist"
        @update:subscription="artist.my_subscription_id = $event.id"
      />

      <div class="text-xs-center">
        <tk-btn flat class="social-icon" @click="share.facebook()">
          <v-icon>fab fa-facebook-f</v-icon>
        </tk-btn>
        <tk-btn flat class="social-icon" @click="share.twitter()">
          <v-icon>fab fa-twitter</v-icon>
        </tk-btn>
        <tk-btn flat class="social-icon" @click="share.linkedin()">
          <v-icon>fab fa-linkedin-in</v-icon>
        </tk-btn>
      </div>

      <div v-if="artist.posts && artist.posts.length">
        <ul class="artist-posts my-2">
          <li
            v-for="post in artist.posts.slice(0, postsExpanded ? artist.posts.length : 3)"
            :key="post.id"
          >
            <router-link
              :to="{ name: 'news.single', params: {newsSlug: post.slug}}"
              class="subheading py-1"
            >{{ post.title }}</router-link>
          </li>
        </ul>

        <div class="text-xs-right" v-if="artist.posts.length > 3">
          <tk-btn
            class="more-btn"
            small
            outline
            @click="postsExpanded = !postsExpanded"
          >{{ $t(postsExpanded ? 'COMMON.LESS' : 'COMMON.MORE') }}</tk-btn>
        </div>
      </div>
    </base-card>
  </div>
</template>

<script>
import * as SocialShare from "@/utils/SocialShare";
import ArtworkSubscribeForm from '../../components/Domain/Artwork/Subscription/ArtworkSubscribeForm'

export default {
  props: {
    artist: {
      required: true
    }
  },

  components: {
    ArtworkSubscribeForm,
    CvDialog: () => import("./CvDialog")
  },

  data() {
    return {
      showCV: false,
      aboutExpanded: false,
      share: SocialShare,
      postsExpanded: false
    };
  },

  computed: {
    aboutProxy() {
      return !this.aboutExpanded && this.artist.about.length > 299
        ? this.artist.about.substring(0, 300) + "..."
        : this.artist.about;
    }
  }
};
</script>




<style scoped lang="scss">

.cv-btn {
  min-width: 35px;
  margin: 0px;
}
.artist-video {
  width: 100%;
  display: block;
  margin-top: 1rem;
  margin-bottom: 1rem;

  @media only screen and (max-width: 464px) {
    height: 160px;
  }
}
ul.artist-posts {
  list-style-type: none;
  padding-left: 0px;
  li {
    a {
      display: block;
      color: #000000;
      &:hover {
        text-decoration: none;
        color: inherit;
      }
    }
  }
}
</style>
